import axios from '@axios'

const route = 'landing_page'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    index(context) {
      return axios.get(`${route}/index`)
    },

    // downloadWindows(context) {
    //   return axios.get(route + '/download_windows', {
    //     responseType: 'blob',
    //   })
    // },

    // downloadLinux(context) {
    //   return axios.get(route + '/download_linux', {
    //     responseType: 'blob',
    //   })
    // },
    // downloadMac(context) {
    //   return axios.get(route + '/download_mac', {
    //     responseType: 'blob',
    //   })
    // },
  },
}
